import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import type { Tag } from './types'

const CaseTag: FC<{
  // Only the display fields are needed; callers pass either a generated case tag
  // or a synthesized one (e.g. the member-facing pseudo-tag).
  tag: Tag
  tagKey: string
}> = props => {
  const { tagKey, tag } = props

  return (
    <Box
      key={tagKey}
      sx={{ mb: 0.25, fontSize: '1.2rem', display: 'inline-flex', bgcolor: 'grey.100', mr: 1 }}
    >
      <Typography
        sx={{
          padding: '0 0.5rem',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          fontSize: '1.2rem',
          display: 'inline-flex',
          fontWeight: 500,
        }}
      >
        {tag.display_name}
      </Typography>
    </Box>
  )
}

export default CaseTag
